import { Controller } from "@hotwired/stimulus"

// Loads the ai-mode.js embed script dynamically for proposal pages
// This ensures the script runs after the chat-container element exists in the DOM
export default class extends Controller {
  static values = {
    websiteId: String,
    mode: { type: String, default: "embed" },
    selector: { type: String, default: "#chat-container" },
    scriptUrl: String
  }

  connect() {
    // Delay to ensure the container element is in the DOM
    // Using a slightly longer delay for Turbo frame updates
    setTimeout(() => {
      this.loadScript()
    }, 100)
  }

  disconnect() {
    // Clean up any existing script when the controller disconnects
    const existingScript = document.querySelector('script[data-ai-embed-script]')
    if (existingScript) {
      existingScript.remove()
    }

    // Also clean up the injected marker so it can be re-injected
    const container = this.element.querySelector(this.selectorValue) || document.querySelector(this.selectorValue)
    if (container) {
      delete container.dataset.ninjaAiModeInjected
      container.innerHTML = ''
    }
  }

  loadScript() {
    // Remove any existing ai-mode script first to allow reinitialization
    const existingScript = document.querySelector('script[data-ai-embed-script]')
    if (existingScript) {
      existingScript.remove()
    }

    // Check if the container already has content injected
    const container = this.element.querySelector(this.selectorValue) || document.querySelector(this.selectorValue)
    if (container && container.dataset.ninjaAiModeInjected === 'true') {
      // Already injected, don't reload
      console.log('[AI Embed Controller] Container already has content, skipping')
      return
    }

    if (!container) {
      console.error('[AI Embed Controller] Container not found:', this.selectorValue)
      return
    }

    console.log('[AI Embed Controller] Loading script for container:', this.selectorValue)

    // Create and load the script with a cache-busting timestamp
    // This ensures the IIFE runs fresh each time
    const script = document.createElement('script')
    const timestamp = Date.now()
    script.src = `${this.scriptUrlValue}?_=${timestamp}`
    script.dataset.websiteId = this.websiteIdValue
    script.dataset.mode = this.modeValue
    script.dataset.selector = this.selectorValue
    script.dataset.aiEmbedScript = 'true'
    script.async = true

    document.body.appendChild(script)
  }
}
